<template>
  <span>
    <span class="text-limited" v-if="!!limitedText" v-tooltip="text" :class="classes" v-bind="{ ...$attrs }">{{
      limitedText || ""
    }}</span>
    <span class="text-limited" v-if="!limitedText" :class="classes" v-bind="{ ...$attrs }"> {{ text }}</span>
  </span>
</template>

<script>
export default {
  data: () => ({
    isLimited: false,
    limitedText: "",
    key: 1,
  }),

  props: {
    text: {
      type: String,
      default: "",
    },

    maxLength: {
      type: Number,
      default: 50,
    },

    classes: {
      type: String,
      default: "",
    },
  },

  beforeMount() {
    this.handleLimitedText();
  },

  methods: {
    handleLimitedText() {
      if (this.text?.length > this.maxLength) {
        this.limitedText = this.text.substr(0, this.maxLength) + "...";
      }
    },
  },
};
</script>

<style scoped lang="scss" src="./styles.scss" />
